import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BorrowerRenderingService } from '../borrower/borrower-rendering.service';
import { OTP } from '../../models/OTP/OTP';

@Injectable({
  providedIn: 'root'
})
export class OTPformBuilderService {

  constructor(private formBuild: FormBuilder, ) { }

  numberRegex = '[0-9]';

  buildOTPForm(Form: FormGroup, OTP: OTP,isFourDigitOTP: boolean) {
   
    let group : any;
    if(isFourDigitOTP)
    {
       group = (
        {
          'otpField1': ['', [Validators.required,Validators.maxLength(1),Validators.pattern(this.numberRegex)]],
          'otpField2': ['', [Validators.required,Validators.maxLength(1),Validators.pattern(this.numberRegex)]],
          'otpField3': ['', [Validators.required,Validators.maxLength(1),Validators.pattern(this.numberRegex)]],
          'otpField4': ['', [Validators.required,Validators.maxLength(1),Validators.pattern(this.numberRegex)]],
        //  'otpField5': ['', [Validators.required,Validators.maxLength(1),Validators.pattern(this.numberRegex)]],
         // 'otpField6': ['', [Validators.required,Validators.maxLength(1),Validators.pattern(this.numberRegex)]]
        }
      )
    }else
    {
       group = (
        {
          'otpField1': ['', [Validators.required,Validators.maxLength(1),Validators.pattern(this.numberRegex)]],
          'otpField2': ['', [Validators.required,Validators.maxLength(1),Validators.pattern(this.numberRegex)]],
          'otpField3': ['', [Validators.required,Validators.maxLength(1),Validators.pattern(this.numberRegex)]],
          'otpField4': ['', [Validators.required,Validators.maxLength(1),Validators.pattern(this.numberRegex)]],
          'otpField5': ['', [Validators.required,Validators.maxLength(1),Validators.pattern(this.numberRegex)]],
          'otpField6': ['', [Validators.required,Validators.maxLength(1),Validators.pattern(this.numberRegex)]]
        }
      )
    }

    Form = this.formBuild.group(group);
    return Form;
  }

}

